import * as React from 'react';

import { ChakraProvider } from '@chakra-ui/react';
import { Analytics } from '@vercel/analytics/react';

export const RootLayout = ({ children }) => (
  <ChakraProvider>
    {children}
    <Analytics />
  </ChakraProvider>
);
